// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import flatpickr from 'flatpickr';

document.addEventListener('turbo:load', () => {
    document.querySelectorAll('[data-behavior="flatpickr"]').forEach((el) => {
        flatpickr(el, {
            enableTime: true,
            dateFormat: 'Y-m-d H:i',
        });
    });
});
